var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.26199 0 9.67145e-05 4.12735 9.67145e-05 9.19425C-0.0343404 16.606 9.139 22.7516 9.5 23C9.5 23 19.0343 16.606 18.9999 9.2C18.9999 4.12735 14.738 0 9.5 0ZM9.5 13.8C6.87565 13.8 4.75005 11.7415 4.75005 9.2C4.75005 6.6585 6.87565 4.6 9.5 4.6C12.1243 4.6 14.25 6.6585 14.25 9.2C14.25 11.7415 12.1243 13.8 9.5 13.8Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.e21de22b407ada1bcd7429f83fcb05aa.svg";
export { ForwardRef as ReactComponent };